import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation(); // ❗ Hook siempre en top-level

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto", // o "smooth"
    });
  }, [pathname]); // ❗ Hook siempre en top-level

  return null;
}
